import React, { useContext } from 'react';
import { FormikInput } from 'Components/frameworks/formik/FormikInput';
import { TemplateString } from 'Components/frameworks/template-string/TemplateString';
import { formatApiDate } from 'Utils/date/apiDate';
import { t } from 'Src/i18n';
import { getPaymentProviderLabel } from 'Components/widgets/payment-info/payment-form/paymentProvidersUtils';
import { PaymentInfoContext } from 'Components/widgets/payment-info/PaymentInfoContext';
import { useB2BPaymentViewContext } from 'Components/widgets/payment-info/b2b-payment-info/B2BPaymentViewContext';
type Props = {
  hasFullAmount: boolean;
  isDisabled: boolean;
  rePaymentSchedule: RepaymentSchedule;
  totalAmount: string;
  totalAmountWithFees: string;
  depositAmount: string;
  depositAmountWithFees: string;
  paymentProvider: PaymentProvider;
  fees: string;
};
export const PayPalPaymentBlock = ({
  hasFullAmount,
  isDisabled,
  rePaymentSchedule,
  totalAmount,
  totalAmountWithFees,
  depositAmount,
  depositAmountWithFees,
  paymentProvider,
  fees,
}: Props) => {
  const { getB2BPaymentProviderLabel } = useB2BPaymentViewContext();
  const { isFreeDeposit } = useContext(PaymentInfoContext);
  const isTotalAmount = isFreeDeposit || hasFullAmount || !rePaymentSchedule;
  const providerLabel =
    getB2BPaymentProviderLabel({
      paymentProvider,
      isTotalAmount,
    }) ||
    getPaymentProviderLabel({
      paymentProvider,
      isTotalAmount,
    });
  return (
    <div data-testid="Type-payment-PayPal" className="my-25 max-w-full text-14 sm:max-w-4/5">
      <input type="hidden" name="paymentProviderId" value={paymentProvider.id} />
      <FormikInput
        type="radio"
        name="selectorPaymentProviderId"
        isDisabled={isDisabled}
        value={paymentProvider.id}
        label={
          <div className="text-14 leading-normal text-black">
            <TemplateString
              template={providerLabel}
              values={
                !isTotalAmount
                  ? {
                      depositAmount: fees ? depositAmountWithFees : depositAmount,
                      balanceAmount: rePaymentSchedule.amount.formattedValue,
                      balanceDate: formatApiDate(
                        rePaymentSchedule.deadline,
                        t('booking.form.dateFormat'),
                      ),
                    }
                  : {
                      totalAmount: fees ? totalAmountWithFees : totalAmount,
                    }
              }
              valuesClassName={{
                depositAmount: 'font-bold text-sienna',
                balanceAmount: 'font-bold text-sienna',
                totalAmount: 'font-bold text-sienna',
                balanceDate: 'font-bold',
              }}
            />{' '}
            {!!fees && (
              <TemplateString
                template={t('booking.banking.paymentProvider.feesApplied')}
                className="text-12"
                values={{
                  fees,
                }}
                valuesClassName={{
                  fees: 'font-bold text-blueWave',
                }}
              />
            )}
          </div>
        }
      />
    </div>
  );
};
